/*
  DogPure · pie de página.
  <dp-footer-group>: acordeón independiente en móvil (cerrado al cargar). Desde 750px el CSS
  muestra los enlaces siempre y el botón se oculta.
  <dp-footer-newsletter>: mensajes de validación en español, estado de envío y protección contra
  doble envío. El envío sigue siendo el formulario nativo de clientes de Shopify.
*/

if (!customElements.get('dp-footer-group')) {
  customElements.define(
    'dp-footer-group',
    class DpFooterGroup extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.dp-footer__toggle');
        if (!this.toggle) return;
        this.onClick = () => this.setOpen(!this.hasAttribute('open'));
        this.toggle.addEventListener('click', this.onClick);
        this.setOpen(this.hasAttribute('open'));

        // Editor del tema: abrir el grupo al seleccionar su bloque
        this.onSelect = (event) => {
          if (event.target === this) this.setOpen(true);
        };
        document.addEventListener('shopify:block:select', this.onSelect);
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onClick);
        document.removeEventListener('shopify:block:select', this.onSelect);
      }

      setOpen(open) {
        this.toggleAttribute('open', open);
        this.toggle.setAttribute('aria-expanded', String(open));
      }
    }
  );
}

if (!customElements.get('dp-footer-newsletter')) {
  customElements.define(
    'dp-footer-newsletter',
    class DpFooterNewsletter extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[type="email"]');
        this.button = this.querySelector('button[type="submit"]');
        this.label = this.querySelector('.dp-footer__submit-label');
        this.message = this.querySelector('.dp-footer__message');
        if (!this.form || !this.input || !this.button) return;

        this.buttonText = this.label.textContent;
        this.form.noValidate = true;
        // Se valida en el clic del botón (Enter también lo dispara): el script anti-spam de Shopify
        // escucha el «submit» de los formularios de clientes y puede reenviarlo aunque se cancele.
        this.button.addEventListener('click', (event) => this.onSubmit(event));
        this.form.addEventListener('submit', (event) => {
          if (!this.input.validity.valid) {
            event.preventDefault();
            return;
          }
          this.setBusy(true);
        });
        this.input.addEventListener('input', () => {
          if (this.input.getAttribute('aria-invalid') === 'true' && this.input.validity.valid) this.clearMessage();
        });
        // Al volver con el botón «atrás» la página puede restaurarse desde caché con el botón bloqueado
        window.addEventListener('pageshow', () => this.setBusy(false));
      }

      onSubmit(event) {
        if (this.busy) {
          event.preventDefault();
          return;
        }

        this.input.value = this.input.value.trim();
        if (!this.input.validity.valid) {
          event.preventDefault();
          const text = this.input.validity.valueMissing ? this.dataset.msgEmpty : this.dataset.msgInvalid;
          this.showError(text);
          this.input.focus();
          return;
        }

        this.clearMessage();
      }

      setBusy(busy) {
        this.busy = busy;
        if (busy) this.button.setAttribute('aria-disabled', 'true');
        else this.button.removeAttribute('aria-disabled');
        this.label.textContent = busy ? this.dataset.msgSending : this.buttonText;
      }

      showError(text) {
        this.input.setAttribute('aria-invalid', 'true');
        this.message.className = 'dp-footer__message dp-footer__message--error';
        this.message.innerHTML = '';
        const icon = this.closest('.dp-footer')?.querySelector('[data-dp-error-icon]');
        if (icon) this.message.append(icon.content.cloneNode(true));
        const span = document.createElement('span');
        span.textContent = text;
        this.message.append(span);
      }

      clearMessage() {
        this.input.removeAttribute('aria-invalid');
        this.message.className = 'dp-footer__message';
        this.message.textContent = '';
      }
    }
  );
}
